import { render, staticRenderFns } from "./FaiSetList.vue?vue&type=template&id=1335080e"
import script from "./FaiSetList.vue?vue&type=script&lang=js"
export * from "./FaiSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports